import { useSelector } from "react-redux";

export const DateFormater = ({ value, type = "default" }) => {
  const locale = useSelector(({ theme }) => theme.locale);
  var formatedDate = ";";
  if (value === null || value === undefined) return "";
  let date = new Date(value);
  if (type == "default") {
    formatedDate = `${new Intl.DateTimeFormat(locale, {
      day: "numeric",
    }).format(date)} ${new Intl.DateTimeFormat(locale, {
      month: "long",
    }).format(date)} ${new Intl.DateTimeFormat(locale, {
      year: "numeric",
    }).format(date)}`;
  } else {
    formatedDate = `${new Intl.DateTimeFormat(locale, {
      month: "long",
    }).format(date)} ${new Intl.DateTimeFormat(locale, {
      year: "numeric",
    }).format(date)}`;
  }

  return formatedDate;
};
